import { createAxiosInstanceSetAction } from "./../actions/axios";
import { createAppDataReceivedAction } from "../actions/appData";
import { put, call, take, all, fork } from "redux-saga/effects";
import { requestAppData } from "../../data/app-data";
import { AXIOS_INSTANCE_SET } from "../actions/axios";
import { IAppData } from "../reducers/appDataReducer";
import { companyCrudSaga } from "./app-data/companies";
import { groupCrudSaga } from "./app-data/groups";
import { roleCrudSaga } from "./app-data/roles";
import { eldCrudSaga } from "./app-data/elds";

export function* appDataSaga() {
  yield all(
    [
      loadAppDataSaga,
      companyCrudSaga,
      groupCrudSaga,
      roleCrudSaga,
      eldCrudSaga,
    ].map(fork)
  );
}

function* loadAppDataSaga() {
  const axiosInstanceAction: ReturnType<typeof createAxiosInstanceSetAction> = yield take(
    AXIOS_INSTANCE_SET
  );
  const appData: IAppData = yield call(
    requestAppData,
    axiosInstanceAction.payload.axios,
    axiosInstanceAction.payload.baseURL
  );
  yield put(createAppDataReceivedAction(appData));
}
